import { getOcrBuildersConfigs } from 'api/ocrBuildersConfig'
import { useLoaderData } from 'react-router-dom'

export default async function loader() {
  return await getOcrBuildersConfigs()
}

export function useOcrBuilderConfigLoader() {
  return useLoaderData() as Awaited<ReturnType<typeof loader>>
}
